/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_Deadline_ShortInputs */

const en_task_settings_deadline_short = /** @type {(inputs: Task_Settings_Deadline_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deadline`)
};

const pt_br2_task_settings_deadline_short = /** @type {(inputs: Task_Settings_Deadline_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo`)
};

/**
* | output |
* | --- |
* | "Deadline" |
*
* @param {Task_Settings_Deadline_ShortInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_deadline_short = /** @type {((inputs?: Task_Settings_Deadline_ShortInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_Deadline_ShortInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_deadline_short(inputs)
	return pt_br2_task_settings_deadline_short(inputs)
});